// Podaci sredstva koji se ne mijenjaju po godinama (dokument nabave, početak amortizacije, vijek trajanja,
// konto sredstva...). Prikazuju se JEDNOM u zaglavlju kartice, u PDF-u i u Excelu, iz zadnje godine koja ih ima.

export const podaciSredstva = (kartica) => {
  const godine = kartica && Array.isArray(kartica.godine) ? kartica.godine : []
  for (let i = godine.length - 1; i >= 0; i--) {
    const z = godine[i] && godine[i].knjizenje
    if (z && (z.dokumentNabave || z.pocetakAmortizacije || (z.kontoSredstva && z.kontoSredstva.konto))) {
      return {
        dokumentNabave: z.dokumentNabave,
        datumDokumenta: z.datumDokumenta,
        pocetakAmortizacije: z.pocetakAmortizacije,
        vijekMjeseci: z.vijekMjeseci,
        konto: z.kontoSredstva && z.kontoSredstva.konto,
        iskljuceno: z.iskljuceno,
        datumProdaje: z.datumProdaje
      }
    }
  }
  return null
}

// Jedan redak teksta, npr. "Dokument nabave: 5-86 od 31.01.2018 · Početak amortizacije: 01.02.2018 · Vijek trajanja: 12 mj. · Konto sredstva: 0325"
export const podaciSredstvaTekst = (kartica) => {
  const p = podaciSredstva(kartica)
  if (!p) { return '' }
  const d = []
  if (p.dokumentNabave) { d.push('Dokument nabave: ' + p.dokumentNabave + (p.datumDokumenta ? ' od ' + p.datumDokumenta : '')) }
  if (p.pocetakAmortizacije) { d.push('Početak amortizacije: ' + p.pocetakAmortizacije) }
  if (p.vijekMjeseci !== null && p.vijekMjeseci !== undefined) { d.push('Vijek trajanja: ' + p.vijekMjeseci + ' mj.') }
  if (p.konto) { d.push('Konto sredstva: ' + p.konto) }
  if (p.iskljuceno) { d.push('Isključeno') }
  if (p.datumProdaje) { d.push('Datum prodaje: ' + p.datumProdaje) }
  return d.join(' · ')
}

export default {podaciSredstva, podaciSredstvaTekst}
